import { CERTIFICATIONS } from "@/lib/company";
import { BadgeCheck } from "lucide-react";

export default function TrustMarquee() {
  return (
    <section data-testid="trust-marquee" className="bg-brand-cream border-y border-neutral-200 py-6 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 mb-3 text-center">
        <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-bold">
          Our Manufacturing Partners Hold
        </p>
      </div>
      <div className="marquee-track">
        {[...CERTIFICATIONS, ...CERTIFICATIONS].map((c, i) => (
          <div
            key={i}
            className="mx-4 px-5 py-2.5 bg-white border border-neutral-200 rounded-md flex items-center gap-2 shadow-sm whitespace-nowrap"
          >
            <BadgeCheck className="w-4 h-4 text-brand-green" />
            <span className="text-sm font-semibold text-brand-charcoal">{c}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
